import React, { useState, useEffect } from 'react';
import {
  Container,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col
} from 'reactstrap';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import styles from './LandingPage.module.css';

import logo from "../../assets/images/brandstrek-logo.png";
import landingBg from "../../assets/images/landing-bg.png";

const LandingPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const features = [
    {
      title: "Student Management",
      description: "Efficiently manage student records, attendance, and academic performance tracking.",
      symbol: "👥"
    },
    {
      title: "Course Planning",
      description: "Create and manage course schedules, curriculum, and learning materials.",
      symbol: "📚"
    },
    {
      title: "Calendar System",
      description: "Integrated calendar for scheduling classes, events, and important dates.",
      symbol: "📅"
    }
  ];

  return (
    <div className={styles.landingPage}>
      <div className={styles.bgGradient}>
        {/* Animated Background */}
        <div className={styles.animatedBg}>
          <div className={styles.blob1}></div>
          <div className={styles.blob2}></div>
          <div className={styles.blob3}></div>
        </div>

        {/* Navbar */}
        <Navbar
          expand="md"
          fixed="top"
          className={`${styles.glassEffect} ${styles.navbarGlass} ${scrolled ? styles.navbarScrolled : ''
            }`}
        >
          <Container className="d-flex align-items-center">
            <NavbarBrand href="/" className="text-primary fw-bold fs-4">
              <img src={logo} width={120} alt="Logo" className="img-fluid" />
            </NavbarBrand>
            <NavbarToggler onClick={() => setIsOpen(!isOpen)} />
            <Collapse isOpen={isOpen} navbar>
              <Nav className="ms-auto" navbar>
                <NavItem>
                  <NavLink href="#features" className={styles.navLink}>Features</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="#contact" className={styles.navLink}>Contact</NavLink>
                </NavItem>
                <NavItem>
                  <Link to="/login" className={`btn btn-primary ms-3 ${styles.btnPrimary}`}>
                    Login
                  </Link>
                </NavItem>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>

        {/* Hero Section */}
        <Container className="py-5" style={{ marginTop: "6rem" }}>
          <Row className="align-items-center">
            <Col md={6}>
              <h2 className="display-4 fw-bold mb-4">
                Welcome to <span className="text-primary">XSchool</span>
              </h2>
              <p className="lead mb-4">
                A comprehensive school management platform designed to streamline and enhance educational operations.
              </p>
              <Link
                to="/login"
                className={`btn btn-primary btn-lg ${styles.btnPrimary}`}
              >
                Get Started <ArrowRight />
              </Link>
            </Col>
            <Col md={6} className="mt-5 mt-md-0">
              <div className="">
                <img
                  src={landingBg}
                  alt="Dashboard Preview"
                  className="img-fluid rounded"
                />
              </div>
            </Col>
          </Row>
        </Container>

        {/* Features Section */}
        <div id="features" className="py-5">
          <Container>
            <h2 className="display-5 text-center fw-bold mb-5">Key Features</h2>
            <Row>
              {features.map((feature, index) => (
                <Col md={4} key={index} className="mb-4">
                  <div className={`${styles.glassCard} h-100 p-4 rounded-3`}>
                    <div className={styles.featureIcon}>{feature.symbol}</div>
                    <h3 className="h4 text-center mb-3">{feature.title}</h3>
                    <p className="text-muted text-center mb-0">{feature.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </div>

        {/* Contact Section */}
        <div id="contact" className="py-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6}>
                <h2 className="display-5 text-center fw-bold mb-5">Contact Us</h2>
                <div className={`${styles.glassCard} p-4 rounded-3`}>
                  <Form>
                    <FormGroup>
                      <Label for="name">Name</Label>
                      <Input
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Enter your name"
                        className={styles.formControl}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="email">Email</Label>
                      <Input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Enter your email"
                        className={styles.formControl}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="message">Message</Label>
                      <Input
                        type="textarea"
                        name="message"
                        id="message"
                        rows="4"
                        placeholder="Enter your message"
                        className={styles.formControl}
                      />
                    </FormGroup>
                    <Button
                      color="primary"
                      block
                      className={`mt-4 ${styles.btnPrimary}`}
                    >
                      Send Message
                    </Button>
                  </Form>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;